import React, { useState, useEffect } from 'react';
import SEOHead from '../../SEO/SEOHead';
import './AllAnimes.css'; // Add your styling here

const AllAnimes = () => {
  const [animeList, setAnimeList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLetter, setSelectedLetter] = useState('All'); // Default to "All"
  const [currentPage, setCurrentPage] = useState(1);
  const [showPreview, setShowPreview] = useState(false); // State to show/hide preview modal
  const [selectedAnimeId, setSelectedAnimeId] = useState(null); // Store selected anime for preview

  // Function to fetch anime data with pagination
  const fetchAllAnime = async (letter, page = 1) => {
    setLoading(true);
    try {
      let url = `https://api.jikan.moe/v4/anime?page=${page}`;
      
      // If the selected letter is "All", fetch all anime without letter filter
      if (letter !== 'All') {
        url += `&letter=${letter}`;
      }

      const response = await fetch(url);
      const data = await response.json();

      if (data?.data) {
        setAnimeList((prevAnimeList) => [...prevAnimeList, ...data.data]); // Append new data to existing list
      } else {
        console.error('No data found');
      }
    } catch (error) {
      console.error('Error fetching all anime:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllAnime(selectedLetter, currentPage); // Fetch anime data based on the selected letter and page
  }, [selectedLetter, currentPage]);

  // Load more anime when the user scrolls to the bottom
  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
    if (bottom && !loading) {
      setCurrentPage((prevPage) => prevPage + 1); // Increment page when the user reaches the bottom
    }
  };

  // Handle letter navigation
  const handleLetterClick = (letter) => {
    setSelectedLetter(letter);
    setAnimeList([]); // Clear the current list before fetching new data
    setCurrentPage(1); // Reset to page 1
  };

  // Handle preview modal display
  const handlePreview = (animeId) => {
    setSelectedAnimeId(animeId);
    setShowPreview(true); // Show preview modal
  };

  // Close preview modal
  const closePreview = () => {
    setShowPreview(false);
    setSelectedAnimeId(null);
  };

  return (
    <div className="allanime-all-animes-page">
      <SEOHead title="ChibiDash | All Anime Series" description="Browse the complete anime catalog on ChibiDash. Search and filter through thousands of anime series." path="/animehub/all-animes" />
      <h1>All Animes A-Z</h1>

      {/* A-Z Navigation Bar */}
      <div className="allanime-alphabet-navigation">
        {['All', '#', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')].map((letter) => (
          <button
            key={letter}
            className={`allanime-alphabet-btn ${selectedLetter === letter ? 'active' : ''}`}
            onClick={() => handleLetterClick(letter)}
          >
            {letter}
          </button>
        ))}
      </div>

      {loading && <p>Loading all anime...</p>}

      {/* Anime List */}
      <div className="allanime-anime-list" onScroll={handleScroll}>
        {animeList.map((anime) => (
          <div key={anime.mal_id} className="allanime-anime-card">
            <div className="allanime-anime-badge">
              {anime.score && <span className="allanime-anime-score-badge">⭐ {anime.score}</span>}
            </div>
            <img
              src={anime.images?.jpg?.image_url}
              alt={anime.title}
              className="allanime-anime-image"
            />
            <div className="allanime-anime-info">
              <h3 className="allanime-anime-title">{anime.title}</h3>
              <button className="allanime-preview-btn" onClick={() => handlePreview(anime.mal_id)}>
                Preview
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Preview Modal */}
      {showPreview && (
        <div className="allanime-preview-modal">
          <div className="allanime-preview-modal-content">
            <span className="allanime-close-btn" onClick={closePreview}>
              &times;
            </span>
            <h2>Preview for Anime ID: {selectedAnimeId}</h2>
            {/* Add more details or a preview of the anime here */}
          </div>
        </div>
      )}

      {/* Optional: Display message when there are no more anime to load */}
      {animeList.length === 0 && !loading && <p>No anime available for this letter.</p>}
    </div>
  );
};

export default AllAnimes;
